import React, { SyntheticEvent } from 'react'
import { CONSTS } from '../config/const'

const placeholderImage = CONSTS.STRUCTURE_FALLBACK_LOGO_PATH

const onImageError = (e: SyntheticEvent<HTMLImageElement>) => {
    if (e.currentTarget.src === placeholderImage) {
        // If it's already the placeholder image and we have the problem, we remove the image
        e.currentTarget.remove()
    } else {
        e.currentTarget.src = placeholderImage
    }
}

export const StructureLogoOrGeneric = ({
    imageUrl,
    title,
    className,
}: {
    imageUrl: string | undefined
    title: string
    className?: string
}) => {
    return (
        <img
            src={imageUrl ?? placeholderImage}
            title={title}
            alt=""
            onError={onImageError}
            className={className}
        />
    )
}
